const map = {
	"./countries": 9308,
	"./countries.json": 9308,
	"./devSites": 6691,
	"./devSites.json": 6691,
	"./domains": 8871,
	"./domains.json": 8871,
	"./formData": 8852,
	"./formData.json": 8852,
	"./language": 8904,
	"./language.json": 8904,
	"./meetingPlace": 8346,
	"./meetingPlace.json": 8346,
	"./phonePrefixList": 4446,
	"./phonePrefixList.json": 4446,
	"./prodSites": 1865,
	"./prodSites.json": 1865,
	"./qaSites": 9824,
	"./qaSites.json": 9824
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1089;